import styled from "styled-components";

export const Container = styled.div``;

export const Iframe = styled.iframe`
  width: 100%;
  height: ${({ height }) => height ? height : "600px"};
`;
